/**
 * product-landing.js — additive behaviour for the product landing template.
 * Works alongside variant-selector.js / product-gallery.js without
 * modifying them.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---- Size / Design two-tier filter ------------------------------ */
    var sizeButtons = document.querySelectorAll('[data-size-btn]');
    var designPills = document.querySelectorAll('[data-design-pill]');

    function showSizeGroup(size) {
      designPills.forEach(function (pill) {
        var match = pill.getAttribute('data-size-group') === size;
        pill.style.display = match ? '' : 'none';
      });
      sizeButtons.forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-size-btn') === size);
      });
    }

    if (sizeButtons.length && designPills.length) {
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var size = btn.getAttribute('data-size-btn');
          showSizeGroup(size);

          var groupPills = document.querySelectorAll('[data-design-pill][data-size-group="' + size + '"]');
          var hasActive = false;
          groupPills.forEach(function (p) {
            if (p.classList.contains('active')) hasActive = true;
          });
          if (!hasActive && groupPills[0]) {
            groupPills[0].click();
          }
        });
      });

      var initialPill = document.querySelector('[data-design-pill].active') || designPills[0];
      if (initialPill) {
        showSizeGroup(initialPill.getAttribute('data-size-group'));
      }
    }

    /* ---- Robust image swap on variant change --------------------------
       The shared variant-selector.js has its own updateImage() logic, but
       it depends on matching image ids against a thumbnail strip that no
       longer exists in this layout, so it can silently fail to find a
       match. This listener is independent of that: it reads
       window.selectedVariantData (set synchronously by variant-selector.js
       inside its own click handler, which runs before this one) and
       resolves the variant's image defensively across a few possible
       Shopify JSON shapes, so it works even if the shared fallback
       doesn't. */
    var singleGalleryMain = document.querySelector('[data-gallery-main]');
    var singleMainImage = singleGalleryMain ? singleGalleryMain.querySelector('img') : null;

    function resolveVariantImageSrc(variant) {
      if (!variant) return null;
      var img = variant.featured_image || variant.image ||
        (variant.featured_media && variant.featured_media.preview_image);
      if (!img) return null;

      if (typeof img === 'object') {
        if (img.src) return img.src;
        if (img.url) return img.url;
        if (img.id && window.productJSON && window.productJSON.images) {
          var match1 = window.productJSON.images.filter(function (i) {
            return String(i.id) === String(img.id);
          })[0];
          if (match1) return match1.src || match1.url;
        }
      } else if (window.productJSON && window.productJSON.images) {
        var match2 = window.productJSON.images.filter(function (i) {
          return String(i.id) === String(img);
        })[0];
        if (match2) return match2.src || match2.url;
      }
      return null;
    }

    if (singleMainImage) {
      document.querySelectorAll('.variant-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var variant = window.selectedVariantData;
          var newSrc = resolveVariantImageSrc(variant);
          if (!newSrc || singleMainImage.getAttribute('src') === newSrc) return;

          singleMainImage.style.transition = 'opacity 200ms ease';
          singleMainImage.style.opacity = '0';
          setTimeout(function () {
            singleMainImage.src = newSrc;
            singleMainImage.style.opacity = '1';
          }, 150);
        });
      });
    }

    /* ---- Sticky bottom-right video bubble ---------------------------- */
    var stickyVideo = document.querySelector('[data-sticky-video]');
    if (stickyVideo) {
      var videoEl = stickyVideo.querySelector('video');
      var closeBtn = stickyVideo.querySelector('[data-video-close]');
      var muteBtn = stickyVideo.querySelector('[data-video-mute]');
      var mutedIcon = muteBtn ? muteBtn.querySelector('[data-icon-muted]') : null;
      var unmutedIcon = muteBtn ? muteBtn.querySelector('[data-icon-unmuted]') : null;

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          stickyVideo.classList.add('is-hidden');
          if (videoEl) videoEl.pause();
        });
      }

      if (muteBtn && videoEl) {
        muteBtn.addEventListener('click', function () {
          videoEl.muted = !videoEl.muted;
          muteBtn.setAttribute('aria-label', videoEl.muted ? 'Unmute video' : 'Mute video');
          if (mutedIcon) mutedIcon.style.display = videoEl.muted ? '' : 'none';
          if (unmutedIcon) unmutedIcon.style.display = videoEl.muted ? 'none' : '';
        });
      }
    }

    /* ---- Sticky add-to-cart bar ---------------------------------------- */
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var mainAddRow = document.querySelector('.product-form-row');

    if (stickyBar && mainAddRow) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('show');
          } else if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('show');
          } else {
            stickyBar.classList.remove('show');
          }
        });
      }, { threshold: 0 });
      observer.observe(mainAddRow);

      var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var mainAddBtn = document.querySelector('.product-add-btn');
          if (mainAddBtn && !mainAddBtn.disabled) {
            mainAddBtn.click();
          }
        });
      }
    }

  });
})();
